export const styles = theme => ({
  tab: {
    fontFamily: theme.typography.fontKanit,
    opacity: 1,
    fontWeight: 500,
    '&:nth-of-type(even)': {
      borderRight: '1px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
    border: '1px solid #ccc',
    maxWidth: '-webkit-fill-available',
  },
  active_tab: {
    color: 'white',
    fontFamily: theme.typography.fontKanit,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      // paddingLeft: '127px',
      // maxWidth: '-webkit-fill-available',
      width: 200,
    },
    maxWidth: '-webkit-fill-available',
  },
  container: {
    maxHeight: 506,
  },
  icon: {
    padding: theme.spacing(0),
  },
  titleSub: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 14,
    fontWeight: 500,
    paddingTop: theme.spacing(3),
  },
  titleBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 19,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(1),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  titleSecondBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 16,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(1),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  bodyBox: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.line.main}`,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
  },
  bodyAnimationBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.line.main}`,
  },
  img: {
    width: '100%',
  },
});